var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#D4001C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.256,
  d: "M1.379 3.23h1.256m0 0h10.052m-10.052 0v8.796a1.256 1.256 0 0 0 1.257 1.256h6.282a1.256 1.256 0 0 0 1.257-1.256V3.23zm1.885 0V1.975A1.256 1.256 0 0 1 5.776.718H8.29a1.256 1.256 0 0 1 1.257 1.256v1.257m-3.77 3.14v3.77m2.513-3.77v3.77"
})));
export { SvgDeleteIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/deleteIcon.svg";